
















import Vue, { PropType } from 'vue';
  import { PopularPhraseItem } from "../../domain/PopularPhraseItem";
  import { searchPath } from "../../../../../../frontend/helper/searchUrl";

  export default Vue.extend({
    name : 'PopularPhraseItem',
    props : {
      item: {
        type : Object as PropType<PopularPhraseItem>,
        required : true
      }
    },
    computed: {
      // The search page the chip opens, as a category tile opens its category page.
      href(): string | undefined {
        return searchPath( this.item.query ) ?? undefined;
      }
    },
    methods: {
      // Only where the page names no search URL, as on a deal page, does a chip search in place.
      handleClick( event: MouseEvent ) {
        if ( this.href !== undefined ) {
          return;
        }
        event.preventDefault();
        this.$emit('itemClick', this.item );
      }
    }
  })
